<template>
  <div
      :is="driver + '-form'"
      v-model="data"
      :errors="errors"
      :portal="portal"
  />
</template>

<script>
import AdsenseMegaboardBannerForm from './AdsenseMegaboardBanner.vue'
import ArticleCategoryHeaderForm from './ArticleCategoryHeader.vue'
import ArticleCompanyDetailsForm from './ArticleCompanyDetails.vue'
import ArticleDetailsForm from './ArticleDetails.vue'
import ArticleTagHeaderForm from './ArticleTagHeader.vue'
import CompactArticleListForm from './CompactArticleList.vue'
import CompanyDetailsForm from './CompanyDetails.vue'
import EventDetailsForm from './EventDetails.vue'
import EventListForm from './EventList.vue'
import EventTeaserForm from './EventTeaser.vue'
import FileDetailsForm from './FileDetails.vue'
import FileListForm from './FileList.vue'
import GoogleMediumBannerForm from './GoogleMediumBanner'
import HeadlineForm from './Headline'
import ImageForm from './Image'
import ItemListForm from './ItemList'
import JobDetailsForm from './JobDetails'
import JobListForm from './JobList'
import JobTeaserForm from './JobTeaser'
import LargeArticleTeaserForm from './LargeArticleTeaser'
import LargeHeadlineForm from './LargeHeadline'
import MediumAdsenseBannerForm from './MediumAdsenseBanner'
import MediumArticleListForm from './MediumArticleList'
import MediumArticleTeaserForm from './MediumArticleTeaser'
import MediumBannerForm from './MediumBanner'
import MegaboardBannerForm from './MegaboardBanner'
import MegaboxBannerForm from './MegaboxBanner'
import MenuForm from './Menu'
import NewsletterForm from './Newsletter'
import PartnerBrandListForm from './PartnerBrandList.vue'
import PartnerContactListForm from './PartnerContactList.vue'
import PartnerHeaderForm from './PartnerHeader.vue'
import PartnerListForm from './PartnerList.vue'
import PortalArticleListForm from './PortalArticleList.vue'
import RegistrationDetailsForm from './RegistrationDetails.vue'
import RegistrationListForm from './RegistrationList.vue'
import SearchResultsForm from './SearchResults'
import SmallArticleTeaserForm from './SmallArticleTeaser'
import StreamerBannerForm from './StreamerBanner'
import TextForm from './Text'
import TopicHeaderForm from './TopicHeader.vue'
import TopicListForm from './TopicList.vue'
import TopicSponsorshipListForm from './TopicSponsorshipList.vue'
import TopicTeaserForm from './TopicTeaser.vue'
import TopRenderedArticleListForm from './TopRenderedArticleList.vue'

export default {
  components: {
    AdsenseMegaboardBannerForm,
    ArticleCategoryHeaderForm,
    ArticleCompanyDetailsForm,
    ArticleDetailsForm,
    ArticleTagHeaderForm,
    CompactArticleListForm,
    CompanyDetailsForm,
    EventDetailsForm,
    EventListForm,
    EventTeaserForm,
    FileDetailsForm,
    FileListForm,
    GoogleMediumBannerForm,
    HeadlineForm,
    ImageForm,
    ItemListForm,
    JobDetailsForm,
    JobListForm,
    JobTeaserForm,
    LargeArticleTeaserForm,
    LargeHeadlineForm,
    MediumAdsenseBannerForm,
    MediumArticleListForm,
    MediumArticleTeaserForm,
    MediumBannerForm,
    MegaboardBannerForm,
    MegaboxBannerForm,
    MenuForm,
    NewsletterForm,
    PartnerBrandListForm,
    PartnerContactListForm,
    PartnerHeaderForm,
    PartnerListForm,
    PortalArticleListForm,
    RegistrationDetailsForm,
    RegistrationListForm,
    SearchResultsForm,
    SmallArticleTeaserForm,
    StreamerBannerForm,
    TextForm,
    TopicHeaderForm,
    TopicListForm,
    TopicSponsorshipListForm,
    TopicTeaserForm,
    TopRenderedArticleListForm,
  },

  props: {
    driver: {
      required: true
    },

    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
